import React, { useState, useEffect } from 'react';

const Staffomatic = () => {
  const [showProjectDropdown, setShowProjectDropdown] = useState(false);
  const [selectedProject, setSelectedProject] = useState('FDB 13811');
  const [pendingRequests, setPendingRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [staff, setStaff] = useState([]);
  const [currentView, setCurrentView] = useState('overview');
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  const projects = [
    'FDB 13811',
    'Projekt A',
    'Projekt B',
    'Projekt C'
  ];

  const handleProjectSelect = (project) => {
    if (project === 'Projekte verwalten') {
      setCurrentView('projektVerwaltung');
    } else if (project === 'Projekte anlegen') {
      setCurrentView('projektAnlegen');
    } else {
      setSelectedProject(project);
    }
    setShowProjectDropdown(false);
  };

  useEffect(() => {
    const loadPendingRequests = async () => {
      try {
        setLoading(true);
        
        const { getAllStaffForSchedule } = await import('../services/firebaseDienstplanService');
        const staffData = await getAllStaffForSchedule();
        setStaff(staffData);
        
        const { getAllPendingTimeOffRequests } = await import('../services/firebaseDienstplanService');
        const requests = await getAllPendingTimeOffRequests();
        
        const formattedRequests = requests.map(request => {
          const user = staffData.find(u => u.id === request.userId);
          const userName = user ? (user.username || user.name) : request.userId;
          
          return {
            id: request.id,
            userId: request.userId,
            userName: userName,
            date: request.date,
            type: request.type,
            reason: request.reason || '-',
            createdAt: request.createdAt || request.date
          };
        });
        
        const sortedRequests = formattedRequests
          .sort((a, b) => new Date(a.date) - new Date(b.date))
          .slice(0, 5);
 
        setPendingRequests(sortedRequests || []);
      } catch (error) {
        console.error('Fehler beim Laden der offenen Anträge:', error);
        setPendingRequests([]);
      } finally {
        setLoading(false);
      }
    };

    loadPendingRequests();
  }, []);

  const renderProjectDropdown = () => {
    if (!showProjectDropdown) return null;
    
    return (
      <div style={{
        position: 'absolute',
        top: '100%',
        left: 0,
        background: '#1e3a8a',
        border: '1px solid rgba(255,255,255,0.2)',
        borderRadius: '4px',
        minWidth: '200px',
        zIndex: 1000,
        boxShadow: '0 4px 12px rgba(0,0,0,0.3)'
      }}>
        <div 
          style={{ 
            padding: '8px 16px', 
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '12px'
          }}
          onClick={() => handleProjectSelect('Projekte verwalten')}
        >
          <i className="fas fa-cog" style={{ fontSize: '10px' }}></i>
          Projekte verwalten
        </div>
        <div 
          style={{ 
            padding: '8px 16px', 
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            fontSize: '12px'
          }}
          onClick={() => handleProjectSelect('Projekte anlegen')}
        >
          <i className="fas fa-plus" style={{ fontSize: '10px' }}></i>
          Projekte anlegen
        </div>
        <div style={{ 
          borderTop: '1px solid rgba(255,255,255,0.2)', 
          margin: '4px 0' 
        }}></div>
        <div style={{ 
          padding: '8px 16px', 
          fontSize: '12px',
          fontWeight: 'bold',
          color: 'rgba(255,255,255,0.8)'
        }}>
          Projektübergreifend
        </div>
        <div style={{ 
          borderTop: '1px solid rgba(255,255,255,0.2)', 
          margin: '4px 0' 
        }}></div>
        {projects.map((project, index) => (
          <div 
            key={index}
            style={{ 
              padding: '8px 16px', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              fontSize: '12px',
              backgroundColor: project === selectedProject ? 'rgba(255,255,255,0.1)' : 'transparent'
            }}
            onClick={() => handleProjectSelect(project)}
          >
            <i className="fas fa-map-marker-alt" style={{ fontSize: '10px' }}></i>
            {project}
          </div>
        ))}
      </div>
    );
  };

  const renderPendingRequests = () => {
    if (loading) {
      return (
        <div style={{ 
          padding: '12px', 
          textAlign: 'center', 
          color: '#6b7280',
          fontSize: '14px'
        }}>
          Lade Anträge...
        </div>
      );
    }

    if (pendingRequests.length === 0) {
      return (
        <div style={{ 
          padding: '12px', 
          textAlign: 'center', 
          color: '#6b7280',
          fontSize: '14px',
          fontStyle: 'italic'
        }}>
          Keine offenen Anträge
        </div>
      );
    }

    return pendingRequests.map((request, index) => {
      const displayName = request.userName || request.userId || 'Unbekannt';
      const nameParts = displayName.split(' ');
      const initials = nameParts.length >= 2 
        ? (nameParts[0].charAt(0) + nameParts[1].charAt(0)).toUpperCase()
        : displayName.substring(0, 2).toUpperCase();
      
      const date = request.date ? new Date(request.date).toLocaleDateString('de-DE') : '';
      const type = request.type === 'urlaub' || request.type === 'Urlaub' ? 'Urlaubsantrag' : 'Freiwunsch';
      const typeColor = type === 'Urlaubsantrag' ? '#059669' : '#f59e0b';
      
      return (
        <div key={request.id || index} style={{ 
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px',
          border: '1px solid #e5e7eb',
          borderRadius: '4px',
          marginBottom: '6px',
          backgroundColor: '#f9fafb'
        }}>
          <div style={{
            width: '28px',
            height: '28px',
            background: '#3b82f6',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontWeight: '600',
            fontSize: '11px'
          }}>{initials}</div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ 
              fontWeight: '600', 
              fontSize: '12px',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis'
            }}>
              {request.userName || request.userId || 'Unbekannter Benutzer'}
            </div>
            <div style={{ fontSize: '11px', color: '#6b7280' }}>{date}</div>
            <div style={{ fontSize: '10px', color: typeColor, fontWeight: '500' }}>{type}</div>
            {request.reason && request.reason !== '-' && (
              <div style={{ 
                fontSize: '9px', 
                color: '#6b7280', 
                fontStyle: 'italic',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis'
              }}>
                {request.reason}
              </div>
            )}
          </div>
          <div style={{ display: 'flex', gap: '4px' }}>
            <div style={{
              width: '8px',
              height: '8px',
              background: '#ef4444',
              borderRadius: '2px'
            }}></div>
            <div style={{
              width: '8px',
              height: '8px',
              background: '#10b981',
              borderRadius: '2px'
            }}></div>
          </div>
        </div>
      );
    });
  };

  const renderProjektVerwaltung = () => {
    return (
      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '20px'
        }}>
          Projektverwaltung
        </h1>
        
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '20px'
        }}>
          <div style={{
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '20px',
            backgroundColor: '#f9fafb'
          }}>
            <h2 style={{
              fontSize: '18px',
              fontWeight: '600',
              color: '#374151',
              marginBottom: '15px'
            }}>
              Aktive Projekte
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {projects.map((project, index) => (
                <div key={index} style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  padding: '12px',
                  backgroundColor: 'white',
                  borderRadius: '6px',
                  border: '1px solid #e5e7eb'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <div style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      backgroundColor: project === selectedProject ? '#10b981' : '#6b7280'
                    }}></div>
                    <span style={{ fontWeight: '500', color: '#374151' }}>{project}</span>
                  </div>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button style={{
                      background: '#3b82f6',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '6px 12px',
                      fontSize: '12px',
                      cursor: 'pointer'
                    }}>
                      Bearbeiten
                    </button>
                    <button style={{
                      background: '#ef4444',
                      color: 'white',
                      border: 'none',
                      borderRadius: '4px',
                      padding: '6px 12px',
                      fontSize: '12px',
                      cursor: 'pointer'
                    }}>
                      Löschen
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderProjektAnlegen = () => {
    return (
      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '20px'
        }}>
          Neues Projekt erstellen
        </h1>
        
        <div style={{
          maxWidth: '600px',
          margin: '0 auto'
        }}>
          <div style={{
            border: '1px solid #e5e7eb',
            borderRadius: '8px',
            padding: '30px',
            backgroundColor: '#f9fafb'
          }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '8px'
                }}>
                  Projektname
                </label>
                <input 
                  type="text"
                  placeholder="Projektname eingeben..."
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '16px'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '8px'
                }}>
                  Beschreibung
                </label>
                <textarea 
                  placeholder="Projektbeschreibung..."
                  rows="4"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '16px',
                    resize: 'vertical'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '8px'
                }}>
                  Projektleiter
                </label>
                <input 
                  type="text"
                  placeholder="Name des Projektleiters..."
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '16px'
                  }}
                />
              </div>
              <div>
                <label style={{
                  display: 'block',
                  fontSize: '16px',
                  fontWeight: '500',
                  color: '#374151',
                  marginBottom: '8px'
                }}>
                  Startdatum
                </label>
                <input 
                  type="date"
                  style={{
                    width: '100%',
                    padding: '12px 16px',
                    border: '1px solid #d1d5db',
                    borderRadius: '6px',
                    fontSize: '16px'
                  }}
                />
              </div>
              <div style={{
                display: 'flex',
                gap: '15px',
                marginTop: '10px'
              }}>
                <button style={{
                  background: '#10b981',
                  color: 'white',
                  border: 'none',
                  borderRadius: '6px',
                  padding: '12px 24px',
                  fontSize: '16px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  flex: 1
                }}>
                  Projekt erstellen
                </button>
                <button 
                  onClick={() => setCurrentView('overview')}
                  style={{
                    background: '#6b7280',
                    color: 'white',
                    border: 'none',
                    borderRadius: '6px',
                    padding: '12px 24px',
                    fontSize: '16px',
                    fontWeight: '500',
                    cursor: 'pointer',
                    flex: 1
                  }}
                >
                  Abbrechen
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const renderDienstplan = () => {
    return (
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        {/* Top Navigation Bar */}
        <div style={{
          background: 'white',
          borderBottom: '1px solid #e5e7eb',
          padding: '2px 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}>
          {/* Left side - Date and Week Selector */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
            <div style={{ textAlign: 'center' }}>
              <div style={{ fontSize: '18px', fontWeight: '600', color: '#3b82f6' }}>Aug. 2025</div>
              <div style={{ fontSize: '14px', color: '#6b7280', textDecoration: 'underline' }}>Heute</div>
            </div>
            
            {/* Week Selector */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <button style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                borderRadius: '4px'
              }}>
                <i className="fas fa-chevron-left" style={{ color: '#6b7280' }}></i>
              </button>
              
              <div style={{ display: 'flex', gap: '1px' }}>
                {[
                  { week: '31', dates: '28.-03.' },
                  { week: '32', dates: '04.-10.' },
                  { week: '33', dates: '11.-17.' },
                  { week: '34', dates: '18.-24.', active: true },
                  { week: '35', dates: '25.-31.' }
                ].map((item, index) => (
                  <div key={index} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '4px 8px',
                    borderRadius: '6px',
                    backgroundColor: item.active ? '#fbbf24' : 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                    minWidth: '50px'
                  }}>
                    <div style={{
                      width: '24px',
                      height: '24px',
                      borderRadius: '50%',
                      backgroundColor: item.active ? '#fbbf24' : '#f9fafb',
                      border: 'none',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: '12px',
                      fontWeight: 'bold',
                      color: item.active ? '#92400e' : '#9ca3af',
                      marginBottom: '4px'
                    }}>
                      {item.active ? '0' : '+'}
                    </div>
                    <div style={{ fontSize: '12px', fontWeight: '600', color: item.active ? '#3b82f6' : '#6b7280' }}>
                      {item.week} | {item.dates}
                    </div>
                  </div>
                ))}
              </div>
              
              <button style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                padding: '4px',
                borderRadius: '4px'
              }}>
                <i className="fas fa-chevron-right" style={{ color: '#6b7280' }}></i>
              </button>
            </div>
          </div>

          {/* Right side - View Options */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <span style={{ fontSize: '14px', color: '#6b7280' }}>Wochenplan</span>
              <div style={{ display: 'flex', gap: '4px' }}>
                <i className="fas fa-cog" style={{ color: '#6b7280', fontSize: '12px', cursor: 'pointer' }}></i>
                <i className="fas fa-print" style={{ color: '#6b7280', fontSize: '12px', cursor: 'pointer' }}></i>
                <i className="fas fa-ellipsis-h" style={{ color: '#6b7280', fontSize: '12px', cursor: 'pointer' }}></i>
              </div>
            </div>
            
            {/* Vertical Divider */}
            <div style={{
              width: '1px',
              height: '40px',
              backgroundColor: '#e5e7eb'
            }}></div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <span style={{ fontSize: '14px', color: '#6b7280' }}>Zeitraum</span>
              <div style={{ display: 'flex', gap: '4px' }}>
                <span style={{
                  color: '#374151',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}>Tag</span>
                <span style={{
                  color: '#6b7280',
                  fontSize: '12px',
                  cursor: 'pointer'
                }}>Monat</span>
              </div>
            </div>
            
            {/* Vertical Divider */}
            <div style={{
              width: '1px',
              height: '40px',
              backgroundColor: '#e5e7eb'
            }}></div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <span style={{ fontSize: '14px', color: '#6b7280' }}>Ansicht</span>
              <div style={{ display: 'flex', gap: '4px' }}>
                <span style={{
                  color: '#6b7280',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  cursor: 'pointer'
                }}>
                  <i className="fas fa-calendar" style={{ fontSize: '10px' }}></i>
                  Kalender
                </span>
                <span style={{
                  color: '#6b7280',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  cursor: 'pointer'
                }}>
                  <i className="fas fa-list" style={{ fontSize: '10px' }}></i>
                  Liste
                </span>
                <span style={{
                  background: '#dbeafe',
                  color: '#1e40af',
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '4px',
                  cursor: 'pointer',
                  padding: '2px 4px',
                  borderRadius: '3px'
                }}>
                  <i className="fas fa-users" style={{ fontSize: '10px' }}></i>
                  Mitarbeitende
                </span>
              </div>
            </div>
            
            {/* Vertical Divider */}
            <div style={{
              width: '1px',
              height: '40px',
              backgroundColor: '#e5e7eb'
            }}></div>
            
            <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <span style={{ fontSize: '14px', color: '#6b7280' }}>Filter</span>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '6px',
                cursor: 'pointer'
              }}>
                <span style={{ fontSize: '12px', color: '#6b7280' }}>Alle Schichten</span>
                <i className="fas fa-chevron-down" style={{ fontSize: '10px', color: '#6b7280' }}></i>
              </div>
            </div>
          </div>
        </div>

        {/* Main Content Area */}
        <div style={{ flex: 1, display: 'flex', padding: '0 20px 20px 20px' }}>
          {/* Left Sidebar - Employee Management */}
          <div style={{
            width: sidebarCollapsed ? '60px' : '280px',
            background: 'white',
            borderRadius: '8px',
            border: '1px solid #e5e7eb',
            display: 'flex',
            flexDirection: 'column',
            marginRight: '20px',
            transition: 'width 0.3s ease',
            overflow: 'hidden'
          }}
          onClick={() => console.log('Sidebar width:', sidebarCollapsed ? '60px' : '280px')}
          >
            {/* Top Icons */}
            <div style={{
              padding: '16px',
              borderBottom: '1px solid #e5e7eb',
              display: 'flex',
              gap: '8px',
              justifyContent: sidebarCollapsed ? 'center' : 'space-between',
              alignItems: 'center'
            }}>
              <div style={{
                width: '32px',
                height: '32px',
                background: '#f3f4f6',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '14px',
                color: '#6b7280',
                cursor: 'pointer'
              }}>
                <i className="fas fa-users"></i>
              </div>
              {!sidebarCollapsed && (
                <div style={{
                  width: '32px',
                  height: '32px',
                  background: '#f3f4f6',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '14px',
                  color: '#6b7280',
                  cursor: 'pointer'
                }}>
                  <i className="fas fa-user"></i>
                </div>
              )}
              <button
                onClick={() => {
                  console.log('Toggle clicked, current state:', sidebarCollapsed);
                  setSidebarCollapsed(!sidebarCollapsed);
                }}
                style={{
                  width: '24px',
                  height: '24px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: '#6b7280',
                  fontSize: '12px'
                }}
              >
                <i className={`fas fa-chevron-${sidebarCollapsed ? 'right' : 'left'}`}></i>
              </button>
            </div>

            {/* Filter */}
            {!sidebarCollapsed && (
              <div style={{
                padding: '16px',
                borderBottom: '1px solid #e5e7eb'
              }}>
                <div style={{
                  position: 'relative',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <i className="fas fa-search" style={{
                    position: 'absolute',
                    left: '12px',
                    color: '#9ca3af',
                    fontSize: '14px'
                  }}></i>
                  <input
                    type="text"
                    placeholder="Mitarbeitende suchen..."
                    style={{
                      width: '100%',
                      padding: '8px 12px 8px 36px',
                      border: '1px solid #d1d5db',
                      borderRadius: '6px',
                      fontSize: '14px'
                    }}
                  />
                </div>
              </div>
            )}

            {/* Employee List */}
            {!sidebarCollapsed && (
              <div style={{ flex: 1, padding: '16px', overflowY: 'auto' }}>
                <div style={{ marginBottom: '16px' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px',
                    borderRadius: '6px',
                    backgroundColor: '#f9fafb'
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      background: '#3b82f6',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      AE
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                        Albert Einstein
                      </div>
                      <div style={{ fontSize: '12px', color: '#6b7280' }}>
                        Woche 0/- Std. Monat 0/- Std.
                      </div>
                    </div>
                  </div>
                </div>

                <div style={{ marginBottom: '16px' }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    padding: '12px',
                    borderRadius: '6px',
                    backgroundColor: '#f9fafb'
                  }}>
                    <div style={{
                      width: '40px',
                      height: '40px',
                      background: '#3b82f6',
                      borderRadius: '50%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: 'white',
                      fontWeight: '600',
                      fontSize: '14px'
                    }}>
                      MW
                    </div>
                    <div style={{ flex: 1 }}>
                      <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                        Matthias Walder
                      </div>
                      <div style={{ fontSize: '12px', color: '#6b7280' }}>
                        Woche 0/- Std. Monat 0/- Std.
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Bottom Button */}
            {!sidebarCollapsed ? (
              <div style={{
                padding: '16px',
                borderTop: '1px solid #e5e7eb'
              }}>
                <button style={{
                  width: '100%',
                  background: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  padding: '10px 16px',
                  borderRadius: '6px',
                  fontSize: '14px',
                  fontWeight: '500',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '8px'
                }}>
                  <i className="fas fa-user-plus"></i>
                  Mitarbeitende anlegen
                </button>
              </div>
            ) : (
              <div style={{
                padding: '16px',
                borderTop: '1px solid #e5e7eb',
                display: 'flex',
                justifyContent: 'center'
              }}>
                <button style={{
                  width: '32px',
                  height: '32px',
                  background: '#3b82f6',
                  color: 'white',
                  border: 'none',
                  borderRadius: '50%',
                  cursor: 'pointer',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <i className="fas fa-user-plus" style={{ fontSize: '12px' }}></i>
                </button>
              </div>
            )}
          </div>

          {/* Main Grid Area */}
          <div style={{ flex: 1, background: 'white', borderRadius: '8px', border: '1px solid #e5e7eb' }}>
            {/* Grid content will go here */}
          </div>
        </div>
      </div>
    );
  };

  const renderMitarbeiter = () => {
    return (
      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '20px'
        }}>
          Mitarbeiter
        </h1>
        <div style={{
          padding: '20px',
          backgroundColor: '#f9fafb',
          borderRadius: '8px',
          border: '1px solid #e5e7eb'
        }}>
          <p style={{ color: '#6b7280', fontSize: '16px' }}>
            Mitarbeiter-Verwaltung wird hier implementiert...
          </p>
        </div>
      </div>
    );
  };

  const renderAbwesenheiten = () => {
    return (
      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '20px'
        }}>
          Abwesenheiten
        </h1>
        <div style={{
          padding: '20px',
          backgroundColor: '#f9fafb',
          borderRadius: '8px',
          border: '1px solid #e5e7eb'
        }}>
          <p style={{ color: '#6b7280', fontSize: '16px' }}>
            Abwesenheiten-Verwaltung wird hier implementiert...
          </p>
        </div>
      </div>
    );
  };

  const renderBerichte = () => {
    return (
      <div>
        <h1 style={{
          fontSize: '24px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '20px'
        }}>
          Berichte
        </h1>
        <div style={{
          padding: '20px',
          backgroundColor: '#f9fafb',
          borderRadius: '8px',
          border: '1px solid #e5e7eb'
        }}>
          <p style={{ color: '#6b7280', fontSize: '16px' }}>
            Berichte-Funktionalität wird hier implementiert...
          </p>
        </div>
      </div>
    );
  };

  const renderOverview = () => {
    return (
      <>
        <div>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            marginBottom: '15px',
            color: '#374151'
          }}>
            1 Wochenplan für diesen Standort
          </h2>
          <div style={{ 
            display: 'flex', 
            gap: '15px',
            flexWrap: 'wrap'
          }}>
            <div style={{
              width: '120px',
              height: '140px',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              padding: '15px',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '10px'
            }}>
              <div style={{
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                backgroundColor: '#f3f4f6',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#6b7280'
              }}>
                0
              </div>
              <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                KW 34
              </div>
              <button style={{
                background: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                padding: '6px 12px',
                fontSize: '12px',
                fontWeight: '500',
                cursor: 'pointer'
              }}>
                Anzeigen
              </button>
            </div>

            {[35, 36, 37, 38].map(kw => (
              <div key={kw} style={{
                width: '120px',
                height: '140px',
                border: '1px solid #e5e7eb',
                borderRadius: '8px',
                padding: '15px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px'
              }}>
                <div style={{
                  width: '60px',
                  height: '60px',
                  borderRadius: '50%',
                  backgroundColor: '#f9fafb',
                  border: '2px dashed #d1d5db',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '24px',
                  color: '#9ca3af'
                }}>
                  +
                </div>
                <div style={{ fontSize: '14px', fontWeight: '500', color: '#374151' }}>
                  KW {kw}
                </div>
                <button style={{
                  background: '#6b7280',
                  color: 'white',
                  border: 'none',
                  borderRadius: '4px',
                  padding: '6px 12px',
                  fontSize: '12px',
                  fontWeight: '500',
                  cursor: 'pointer'
                }}>
                  Erstellen
                </button>
              </div>
            ))}
          </div>
        </div>

        <div>
          <h2 style={{ 
            fontSize: '18px', 
            fontWeight: '600', 
            marginBottom: '15px',
            color: '#374151'
          }}>
            Termine der nächsten 7 Tage
          </h2>
          <div style={{ 
            display: 'flex',
            gap: '10px',
            alignItems: 'flex-start'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '10px',
              marginTop: '40px'
            }}>
              <div style={{
                width: '24px',
                height: '24px',
                backgroundColor: '#9ca3af',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '12px'
              }}>
                🎁
              </div>
              <div style={{
                width: '24px',
                height: '24px',
                backgroundColor: '#9ca3af',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '12px'
              }}>
                ✈️
              </div>
              <div style={{
                width: '24px',
                height: '24px',
                backgroundColor: '#9ca3af',
                borderRadius: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: 'white',
                fontSize: '12px'
              }}>
                📅
              </div>
            </div>

            <div style={{
              display: 'flex',
              gap: '10px',
              flex: 1
            }}>
              {[
                { day: 'Do.', date: '21.Aug.' },
                { day: 'Fr.', date: '22.Aug.' },
                { day: 'Sa.', date: '23.Aug.' },
                { day: 'So.', date: '24.Aug.' },
                { day: 'Mo.', date: '25.Aug.' },
                { day: 'Di.', date: '26.Aug.' },
                { day: 'Mi.', date: '27.Aug.' }
              ].map((dayInfo, index) => (
                <div key={index} style={{
                  flex: 1,
                  minHeight: '200px',
                  border: '1px solid #e5e7eb',
                  borderRadius: '8px',
                  padding: '10px',
                  backgroundColor: '#f9fafb'
                }}>
                  <div style={{
                    fontSize: '12px',
                    fontWeight: '600',
                    color: '#374151',
                    marginBottom: '10px',
                    textAlign: 'center'
                  }}>
                    {dayInfo.day} {dayInfo.date}
                  </div>
                  <div style={{
                    minHeight: '150px',
                    backgroundColor: 'white',
                    borderRadius: '4px',
                    border: '1px solid #e5e7eb'
                  }}>
                  </div>
                </div>
              ))}
            </div>

            <div style={{
              marginTop: '10px',
              padding: '10px',
              backgroundColor: '#f9fafb',
              borderRadius: '6px',
              border: '1px solid #e5e7eb'
            }}>
              <div style={{ fontSize: '12px', fontWeight: '600', marginBottom: '8px', color: '#374151' }}>
                Legende
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', marginBottom: '4px' }}>
                <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#3b82f6' }}></div>
                <span style={{ fontSize: '11px', color: '#6b7280' }}>Spezielle Tage</span>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <div style={{ width: '12px', height: '12px', borderRadius: '50%', backgroundColor: '#06b6d4' }}></div>
                <span style={{ fontSize: '11px', color: '#6b7280' }}>Bestätigte Abwesenheiten</span>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 240,
      right: 0,
      bottom: 0,
      backgroundColor: '#f3f4f6',
      overflow: 'hidden'
    }}>
      <div style={{
        background: '#1e3a8a',
        color: 'white',
        padding: '12px 20px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        borderBottom: '1px solid rgba(255,255,255,0.1)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <div style={{ position: 'relative' }}>
            <div style={{
              padding: '8px 16px', 
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              gap: '8px'
            }}
            onClick={() => setShowProjectDropdown(!showProjectDropdown)}
          >
            <i className="fas fa-map-marker-alt" style={{ fontSize: '12px' }}></i>
            {selectedProject}
            <i className="fas fa-chevron-down" style={{ fontSize: '10px' }}></i>
          </div>
          {renderProjectDropdown()}
        </div>

          {/* Navigation Items */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <span 
              onClick={() => setCurrentView('overview')}
              style={{ 
                fontSize: '14px', 
                color: currentView === 'overview' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.7)',
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: '4px',
                backgroundColor: currentView === 'overview' ? 'rgba(255,255,255,0.1)' : 'transparent'
              }}
            >
              Übersicht
            </span>
            <span 
              onClick={() => setCurrentView('dienstplan')}
              style={{ 
                fontSize: '14px', 
                color: currentView === 'dienstplan' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.7)',
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: '4px',
                backgroundColor: currentView === 'dienstplan' ? 'rgba(255,255,255,0.1)' : 'transparent'
              }}
            >
              Dienstplan
            </span>
            <span 
              onClick={() => setCurrentView('mitarbeiter')}
              style={{ 
                fontSize: '14px', 
                color: currentView === 'mitarbeiter' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.7)',
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: '4px',
                backgroundColor: currentView === 'mitarbeiter' ? 'rgba(255,255,255,0.1)' : 'transparent'
              }}
            >
              Mitarbeiter
            </span>
            <span 
              onClick={() => setCurrentView('abwesenheiten')}
              style={{ 
                fontSize: '14px', 
                color: currentView === 'abwesenheiten' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.7)',
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: '4px',
                backgroundColor: currentView === 'abwesenheiten' ? 'rgba(255,255,255,0.1)' : 'transparent'
              }}
            >
              Abwesenheiten
            </span>
            <span 
              onClick={() => setCurrentView('berichte')}
              style={{ 
                fontSize: '14px', 
                color: currentView === 'berichte' ? 'rgba(255,255,255,0.9)' : 'rgba(255,255,255,0.7)',
                cursor: 'pointer',
                padding: '8px 12px',
                borderRadius: '4px',
                backgroundColor: currentView === 'berichte' ? 'rgba(255,255,255,0.1)' : 'transparent'
              }}
            >
              Berichte
            </span>
          </div>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
          <i className="fas fa-bell" style={{ cursor: 'pointer' }}></i>
          <i className="fas fa-plus" style={{ cursor: 'pointer' }}></i>
          <i className="fas fa-user" style={{ cursor: 'pointer' }}></i>
          <span>Übersicht Bremen</span>
        </div>
      </div>

      <div style={{ 
        display: 'flex', 
        height: 'calc(100vh - 110px)',
        padding: '20px',
        gap: currentView === 'overview' ? '20px' : '0'
      }}>
        <div style={{ 
          flex: 1,
          background: 'white',
          borderRadius: '8px',
          padding: '20px',
          display: 'flex',
          flexDirection: 'column',
          gap: '20px'
        }}>
          {currentView === 'projektVerwaltung' ? renderProjektVerwaltung() : 
           currentView === 'projektAnlegen' ? renderProjektAnlegen() : 
           currentView === 'dienstplan' ? renderDienstplan() :
           currentView === 'mitarbeiter' ? renderMitarbeiter() :
           currentView === 'abwesenheiten' ? renderAbwesenheiten() :
           currentView === 'berichte' ? renderBerichte() :
           renderOverview()}
        </div>

        {currentView === 'overview' && (
          <div style={{ 
            width: '300px',
            background: 'white',
            borderRadius: '8px',
            padding: '20px',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}>
            <div style={{ 
              display: 'flex', 
              borderBottom: '1px solid #e5e7eb',
              marginBottom: '20px'
            }}>
              <div style={{ 
                padding: '10px 16px',
                borderBottom: '2px solid #3b82f6',
                color: '#3b82f6',
                fontWeight: '600',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                Abwesenheiten
                <span style={{
                  background: '#fbbf24',
                  color: 'white',
                  borderRadius: '50%',
                  width: '16px',
                  height: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 'bold'
                }}>1</span>
              </div>
              <div style={{ 
                padding: '10px 16px',
                color: '#6b7280',
                fontWeight: '500',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}>
                Nachrichten
                <span style={{
                  background: '#fbbf24',
                  color: 'white',
                  borderRadius: '50%',
                  width: '16px',
                  height: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '10px',
                  fontWeight: 'bold'
                }}>0</span>
              </div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <div style={{ 
                fontSize: '12px', 
                color: '#666', 
                marginBottom: '10px',
                fontWeight: 'bold'
              }}>
                Offene Freischichten und Urlaubsanträge ({pendingRequests.length})
              </div>
              {renderPendingRequests()}
            </div>

            <div style={{ marginBottom: '20px' }}>
              <h3 style={{ 
                fontSize: '16px', 
                fontWeight: '600', 
                marginBottom: '12px',
                color: '#374151'
              }}>Aktuelle Belegungen</h3>
              <div style={{ 
                color: '#6b7280', 
                fontSize: '14px',
                fontStyle: 'italic'
              }}>Keine Daten vorhanden</div>
            </div>

            <div style={{ marginBottom: '20px' }}>
              <h3 style={{ 
                fontSize: '16px', 
                fontWeight: '600', 
                marginBottom: '12px',
                color: '#374151'
              }}>Letzte Aktivitäten</h3>
              {[1, 2, 3].map((_, index) => (
                <div key={index} style={{ 
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  padding: '8px 0',
                  borderBottom: index < 2 ? '1px solid #f3f4f6' : 'none'
                }}>
                  <div style={{
                    width: '28px',
                    height: '28px',
                    background: '#3b82f6',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: '600',
                    fontSize: '11px'
                  }}>MW</div>
                  <div style={{ flex: 1, fontSize: '13px' }}>
                    <span>Matthias Walder hat eine </span>
                    <span style={{ fontWeight: '600' }}>Schicht</span>
                    <span> erstellt</span>
                  </div>
                  <div style={{ 
                    fontSize: '11px', 
                    color: '#6b7280',
                    whiteSpace: 'nowrap'
                  }}>vor 10 Minuten</div>
                </div>
              ))}
            </div>

            <div style={{ 
              position: 'absolute',
              bottom: '20px',
              right: '20px'
            }}>
              <button style={{
                background: '#3b82f6',
                color: 'white',
                border: 'none',
                borderRadius: '50%',
                width: '50px',
                height: '50px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(59, 130, 246, 0.3)'
              }}>
                <i className="fas fa-question" style={{ fontSize: '16px' }}></i>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Staffomatic;
